/**
 * Set the default number of events tickets to 1 instead of 0
 *
 * Having the default number of tickets set to 0 instead of 1 causes confusion when registering for an event since
 * the button to add tickets is disabled until you have at least 1 ticket set. There is no way to do this using the
 * events calendar plugin settings. It has been reported as an issue before but has not been fixed and Modern Tribe
 * released an extension for it.
 *
 * @see https://github.com/mt-support/tribe-ext-set-ticket-default-quantity/tree/master
 * @see https://theeventscalendar.com/support/forums/topic/change-default-ticket-number-from-0-to-1/
 */

/**
 * Set the default number of events tickets to 1 instead of 0
 *
 * Having the default number of tickets set to 0 instead of 1 causes confusion when registering for an event since
 * the button to add tickets is disabled until you have at least 1 ticket set. There is no way to do this using the
 * events calendar plugin settings. It has been reported as an issue before but has not been fixed and Modern Tribe
 * released an extension for it.
 *
 * @see https://github.com/mt-support/tribe-ext-set-ticket-default-quantity/tree/master
 * @see https://theeventscalendar.com/support/forums/topic/change-default-ticket-number-from-0-to-1/
 */

export const setDefaultTicketQuantity = () => {
    const container = document.querySelector('.tribe-events-tickets');
    const blockContainer = document.querySelector('form#tribe-tickets');
    const v2Container = document.querySelector('.tribe-tickets__tickets-form');

    if (container) {
        const inputs = container.querySelectorAll<HTMLInputElement>(
            'input.tribe-tickets-quantity, .woocommerce .quantity input.qty, .edd.quantity input.edd-input'
        );

        inputs.forEach((input) => {
            input.value = '1';
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    if (blockContainer) {
        const inputs = blockContainer.querySelectorAll<HTMLInputElement>('input.tribe-tickets-quantity');

        inputs.forEach((input) => {
            input.value = '1';
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    if (v2Container) {
        const addButton = document.querySelector<HTMLElement>('.tribe-tickets__tickets-item-quantity-add');
        if (addButton) {
            addButton.click();
        }
    }
}